import { THEMES } from 'src/constants';

export const bmw = {
    siteName: 'bmw',
    senderName: 'BMW',
    logo: '/static/warbox_logo.png',
    name: 'BMW',
    bureauSite: 'bmw.warbox.io',
    theme: THEMES.LIGHT,
    client: 'bmw-group',
    themes: [
        { theme: 'LIGHT', name: 'LIGHT' },
        { theme: 'ONE_DARK', name: 'DARK' },
        { theme: 'DARK_PINK', name: 'DARK PINK' },
        { theme: 'LIGHT_PINK', name: 'LIGHT PINK' },
        { theme: 'DARK_BLUE', name: 'DARK BLUE' },
        { theme: 'LIGHT_BLUE', name: 'LIGHT BLUE' },
        { theme: 'DARK_RED', name: 'DARK RED' },
        { theme: 'LIGHT_RED', name: 'LIGHT RED' },
        { theme: 'DARK_LILA', name: 'DARK LILA' },
        { theme: 'LIGHT_LILA', name: 'LIGHT LILA' },
    ],
};
